// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_keycap/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_keycap: ModuleSchema = {
  "id": "core_keycap",
  "uniqueId": "B3D_KCAP1",
  "createdAt": "2026-10-02T01:46:00Z",
  "updatedAt": "2026-10-28T14:58:32.089Z",
  "label": "Keycap Stem Core",
  "description": "Mechanical Keyboard Keycap & Stem mount built from core_geometry/keycap.h",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_KCAP01",
    "keycap"
  ],
  "sliders": [
    {
      "key": "width",
      "label": "Keycap Width & Depth",
      "min": 15,
      "max": 30,
      "default": 21.5,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "height",
      "label": "Keycap Total Height",
      "min": 4,
      "max": 14,
      "default": 6,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "fillet",
      "label": "Corner Fillet Radius",
      "min": 0.5,
      "max": 8,
      "default": 3.75,
      "step": 0.25,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "wallThickness",
      "label": "Wall Thickness",
      "min": 0.8,
      "max": 3,
      "default": 1.2,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "roofThickness",
      "label": "Roof / Top Face Thickness",
      "min": 0.8,
      "max": 4,
      "default": 2,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "stemPostW",
      "label": "Stem Post Width X (tru chu thap - canh dai)",
      "min": 3,
      "max": 8,
      "default": 6.5,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "stemPostD",
      "label": "Stem Post Depth Y",
      "min": 2.5,
      "max": 7,
      "default": 5,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "keycap",
      "label": "Keycap Shell with Cross Stem",
      "default": "#F3F4F6",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "keycap",
      "label": "Keycap with Cross Stem",
      "name": "Keycap with Cross Stem",
      "color": "#F3F4F6",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "keycap",
          "label": "Keycap Shell with Cross Stem",
          "name": "Keycap Shell with Cross Stem",
          "groupId": 0,
          "colorKey": "keycap",
          "defaultColor": "#F3F4F6",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Keycap with Cross Stem"
    }
  ]
};
